import React from 'react';
import GuestKioskApp from './GuestKioskApp';

function App() {
  return <GuestKioskApp />;
}

export default App;
